import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { DTypeFormLanguageTextField } from '@grupo-constant/next-dtype/form';
import { DTypeViewableCol } from '@grupo-constant/next-dtype/types';
import { LangDefinition, TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { DTypeFormFieldComponent } from '../../dtype-field.model';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LocalizePipe } from '../../../pipes/standalone/localize.pipe';
import { GetFormControlPipe } from '../../../pipes/get-form-control.pipe';
import { langDefinition } from '../../../../app.config';

@Component({
    selector: 'localetext-field-component',
    templateUrl: './localetext-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, MatButtonModule, MatIconModule, MatSelectModule, LocalizePipe, TranslocoModule,
        GetFormControlPipe, MatFormFieldModule, MatInputModule, MatOptionModule, ReactiveFormsModule, FormsModule]
})
export class DtypeLocaleTextFieldComponent implements DTypeFormFieldComponent, OnInit {

    @Input() field: DTypeFormLanguageTextField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    /** LangDefinition as defined in transloco.module */
    availableLangs: LangDefinition[];

    selectedLang: string;

    constructor(private translocoService: TranslocoService) { }

    ngOnInit() {
        this.availableLangs = this.translocoService.getAvailableLangs().map(lang => langDefinition[lang.id]);
        this.selectedLang = this.translocoService.getActiveLang();

        const readonlyOnUpdate = (this.field.dTypeCol as DTypeViewableCol).readonlyOnUpdate;
        if (readonlyOnUpdate && this.isUpdate) {
            this.field.readonly = true;
        }
    }

}
